import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

interface Props {
  upperBound: number;
}

const HeatmapLegend: React.FC<Props> = (props) => {
  const svgRef = useRef(null);
  useEffect(() => {
    const svg = d3.select(svgRef.current);
    const colorScale = d3
      .scaleSequential()
      .interpolator(d3.interpolateRgbBasis(["#c82121", "white"]))
      .domain([0, props.upperBound]); // Define your domain based on the range of values in your heatmap; // You can choose any color scheme you like

    let values = [];
    for (let i = 0; i <= props.upperBound; i += 3) {
      values.push(parseFloat(i.toFixed(2)));
    }

    const categories = values.map((val, i) => {
      return {
        val: val,
        color: colorScale(val),
      };
    });

    svg
      .selectAll(".heatmap-legend")
      .data(categories)
      .enter()
      .append("rect")
      .attr("fill", (d) => d.color)
      .attr("x", 0)
      .attr("y", (d, i) => 15 * i)
      .attr("width", 25)
      .attr("height", 20)
      .attr("rx", 5);
  }, []);

  return (
      <svg ref={svgRef} width={25} height={460}></svg>
  );
};

export default HeatmapLegend;
